var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 248,
    rx: 40,
    ry: 40,
    fill: "#0161FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,186) scale(0.05,-0.05)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1987 2054 c15 -11 38 -36 51 -54 22 -33 22 -35 22 -431 0 -386 -1 -400 -20 -419 -29 -29 -90 -27 -124 5 l-26 24 0 366 0 365 -670 0 -669 0 -3 -364 -3 -364 -24 -26 c-32 -34 -80 -35 -117 -2 l-28 23 3 399 c3 450 3 448 74 483 41 21 51 21 774 19 725 -3 732 -3 760 -24z m-437 -486 c42 -46 32 -62 -154 -246 -108 -107 -181 -172 -193 -172 -25 0 -52 20 -165 123 -77 69 -88 83 -88 113 0 39 29 64 73 64 22 0 45 -16 98 -67 l70 -67 137 137 c119 119 141 137 169 137 20 0 40 -8 53 -22z m-475 -545 c31 -56 66 -76 138 -81 53 -3 67 0 97 20 19 13 44 40 55 61 l20 37 423 0 c467 0 441 4 428 -64 -9 -45 -44 -96 -83 -119 -27 -15 -58 -19 -185 -22 -110 -2 -166 -8 -198 -19 -76 -28 -83 -37 -353 -431 -60 -88 -121 -172 -135 -188 -28 -29 -75 -36 -102 -14 -23 18 -96 117 -247 335 -165 240 -166 240 -208 270 -51 36 -134 52 -281 52 -119 0 -134 2 -164 23 -45 30 -69 65 -76 109 -12 73 -41 68 428 68 l423 0 20 -37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6437be57723c6a42cc814063207979b2.svg";
export { ForwardRef as ReactComponent };